import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { basicValidation } from "../../../amorg-common";
import { confirmPasswordReset } from "../../../api/userClientApi";
import { Button } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { TextField } from "../../../designSystem/formField/text/TextField";
import { SingleColumnLayout } from "../../_layouts/SingleColumnLayout";
import { MessageCard } from "../../../designSystem/MessageCard";
import { PageHeader } from "../../../designSystem/PageHeader";

type ResultType = 'none' | 'error' | 'success';

export function PasswordResetConfirmationPanel (): JSX.Element
{
    const [result, setResult] = React.useState<ResultType>('none');
    const [newPW1, setNewPW1] = useState<string>('');
    const [newPW2, setNewPW2] = useState<string>('');

    const params = useParams<{ siteId: string, userId: string, requestId: string; }>();

    async function onChangePasswordClick ()
    {
        const result = await confirmPasswordReset(params.siteId, params.userId, params.requestId, newPW1);
        if (result.isSuccess)
        {
            setResult('success');
        }
        else
        {
            setResult('error');
        }
    }

    const newPassword1IsValid = newPW1 === "" || basicValidation.isValidPassword(newPW1);
    const newPassword2IsValid = newPW2 === newPW1;
    const formIsValid = newPassword1IsValid && newPassword2IsValid;
    return (
        <>
        <PageHeader headerText='Opret ny adgangskode' narrow />
        <SingleColumnLayout narrow>
            <>
                <Flex flexDirection="column" gap={24} style={{ width: '600px', margin: 'auto' }}>

                    {result === 'success' &&
                        <MessageCard variant={result}>
                            <>Din adgangskoden er ændret.<br /> 
                            <br />
                            <a href="/login">Log ind med din nye adgangskode her</a></>
                        </MessageCard>
                    }

                    {result === 'error' &&
                        <MessageCard variant={result}>
                            <>
                                Vi kunne ikke ændre din adgangskode. E-mail linket er muligvis allerede aktiveret.
                                Prøv igen og kontakt support hvis det ikke lykkes.
                            </>
                        </MessageCard>
                    }

                    <Flex flexDirection='column' gap={16}>

                        <TextField
                            label="Indtast din nye adgangskode"
                            type="password"
                            value={newPW1}
                            onChange={(value) => setNewPW1(value)}
                            disabled={result === 'success'}
                            validator={() => newPassword1IsValid
                                ? { valid: true }
                                : { valid: false, errorMessage: "Ugyldig adgangskode" }
                            }
                        />

                        <TextField
                            label="Gentag din nye adgangskode"
                            type="password"
                            value={newPW2}
                            onChange={(value) => setNewPW2(value)}
                            disabled={result === 'success'}
                            validator={() => newPassword2IsValid
                                ? { valid: true }
                                : { valid: false, errorMessage: "Skal matche ny adgangskode" }
                            }
                        />

                        <ButtonRow>
                            <Button variant="filled"
                                disabled={result === 'success' || !formIsValid || newPW1 === ''}
                                onClick={onChangePasswordClick}
                                text={"Skift adgangskode"}
                            />
                        </ButtonRow>

                    </Flex>

                </Flex>
            </>
        </SingleColumnLayout>
        </>
    );
}